import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetTaxes } from "api/setup";
import { GetUserRoles } from "api/user";

export const userRolesGetThunk = createAsyncThunk(
    'user-roles-get',
    async () => {
        const res = await GetUserRoles();
        return res;
    },
);

export const taxesGetThunk = createAsyncThunk(
    'taxes-get',
    async () => {
        const res = await GetTaxes();
        return res;
    },
);